/**
 * Environment variables schema for the application.
 * Validates and types all required environment variables.
 * 
 * @remarks
 * Environment variables should only include values that differ between environments (prod/stage),
 * such as API keys and service URLs. Business logic values such as:
 * - PRICE_MONTH_RATE
 * - DYNAMIC_PRICING_ENABLED
 * - MIN_TRIP_DISTANCE
 * - MAX_TRIP_DISTANCE
 * - DEFAULT_FARE_PER_KM
 * - SURGE_PRICING_MULTIPLIER
 * - CANCELLATION_FEE
 * should be moved to application constants instead, as they:
 * - Need to be version controlled
 * - Are part of business logic
 * - Don't typically change between environments
 * - Should be reviewed and tested with code changes
 */
import { object, string } from "zod"
import type { z } from "zod"

/**
 * 
 */
const EnvSchema = object({
	VITE_SUPABASE_URL: string(),
	VITE_SUPABASE_ANON_KEY: string(),
	VITE_GOOGLE_MAPS_KEY: string(),
	VITE_DISTANCEMATRIXAI_KEY: string().optional(),
	VITE_OPENROUTESERVICE_KEY: string().optional(),
	VITE_STRIPE_PUBLIC_KEY: string(),
	VITE_GTM_ID: string(),
})

export type Env = z.infer<typeof EnvSchema>

export const env = EnvSchema.parse(import.meta.env)
